<!-- @format -->

<template>
  <div class="form-div">
    <alert-box
      :alertText="errMsg"
      :alertType="errType"
      v-if="alert"
    ></alert-box>
    <teleport to="#app">
      <confirm-box ref="confirm"></confirm-box>
      <MessageBox ref="msgbox"></MessageBox>
      <popup-loader
        :LoaderText="'Please wait..'"
        v-if="ispopupLoading == true"
      ></popup-loader>
      <student-track
        @on-select="selectStudent"
        @on-close="closeTrack"
        :classfilter="this.formData.class"
        v-if="studenttrack == true"
      ></student-track>
    </teleport>
    <div class="title-bar">
      <div class="title-text">Class Messages Report</div>
      <div class="close-btn">
        <router-link to="/dashboard">
          <span class="fas fa-times-circle"></span
        ></router-link>
      </div>
    </div>
    <div class="content-area">
      <div class="filter-area">
        <div class="row">
          <div class="col">
            <table>
              <tr>
                <td>
                  <label> From Date:</label>
                </td>
                <td>
                  <input
                    type="date"
                    class="form-control"
                    v-model="formData.mdate1"
                  />
                </td>
                <td>
                  <label> To Date:</label>
                </td>
                <td>
                  <input
                    type="date"
                    class="form-control"
                    v-model="formData.mdate2"
                  />
                </td>
                <td><label for="class">Class</label></td>
                <td>
                  <select
                    name="cldes"
                    class="form-select"
                    v-model="cmbclass"
                    tabindex="2"
                    ref="class"
                    @blur="fillClass"
                  >
                    <option :value="''">--Select--</option>
                    <option
                      v-for="item in classesList"
                      :key="item.class"
                      :value="item"
                    >
                      {{ item.cldes }}
                    </option>
                  </select>
                </td>
              </tr>
            </table>
          </div>

          <div class="col">
            <table class="tbl">
              <tr>
                <td>Student Name &nbsp; &nbsp;</td>
                <td>
                  <input
                    ref="gln"
                    type="text"
                    name="gln"
                    class="form-control gln"
                    v-model="formData.gln"
                    autocomplete="off"
                    maxlength="80"
                    tabindex="4"
                    readonly
                  />
                </td>
                <td>
                  <button
                    class="btn btn-primary"
                    type="button"
                    @click="studenttrack = !studenttrack"
                    ref="glcbtn"
                  >
                    ...
                  </button>
                </td>
              </tr>
            </table>
          </div>
        </div>

        <div class="filter-btns" v-if="showfilter == true">
          <button type="button" class="btn btn-primary" @click="filterRec">
            Filter
          </button>
          &nbsp;&nbsp;&nbsp;
          <button type="button" class="btn btn-primary" @click="clearFilter">
            Clear Filter
          </button>
          &nbsp;&nbsp;&nbsp;

          <button type="button" class="btn btn-info" @click="exportExcel">
            Export
          </button>
          &nbsp;&nbsp;&nbsp;

          <button type="button" class="btn btn-warning" @click="exportStuExcel">
            Export Student Excel
          </button>
          <a :href="xlslink" class="xlslink" v-if="xlslink != ''">Download</a>
        </div>

        <input
          type="text"
          class="form-control searchbox"
          placeholder="Search"
          v-model="search"
          ref="search"
          autofocus
        />
      </div>
      <div class="grid-area">
        <CardLoader :LoaderText="loadertext" v-if="loading == true" />
        <div v-else class="students-list">
          <div class="student-table-div">
            <table>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Student Code</th>
                  <th>Student Name</th>
                  <th>Class</th>
                  <th>Section</th>
                  <th>Message</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(stu, index) in studentList" :key="index">
                  <td>{{ toBritish(stu.docdt) }}</td>
                  <td>{{ stu.glc }}</td>
                  <td>{{ stu.gln }}</td>
                  <td>{{ stu.cldes }}</td>
                  <td>{{ stu.sec }}</td>
                  <td>{{ stu.msg }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AlertBox from "@/components/AlertBox.vue";
import CardLoader from "@/components/CardLoader.vue";
import ConfirmBox from "@/components/ConfirmBox.vue";
import axios from "axios";
import MyFun from "@/js/MyFun";
import MessageBox from "@/components/MessageBox.vue";
import PopupLoader from "../../components/PopupLoader.vue";
import StudentTrack from "../../components/StudentTrack.vue";

export default {
  components: {
    AlertBox,
    CardLoader,
    ConfirmBox,
    MessageBox,
    PopupLoader,
    StudentTrack,
  },
  data() {
    return {
      formId: "012",
      permission: [],
      studentArr: [],
      cmbclass: "",
      choosenmsg: "",
      addForm: false,
      optn: "Add",
      hidetable: false,
      showfilter: true,
      ispopupLoading: false,
      search: "",
      mstList: [],
      userId: this.$store.state.userId,
      userName: this.$store.state.userName,
      errMsg: "",
      errType: "",
      alert: false,
      loading: false,
      ecode: "",
      loadertext: "Please Wait..",
      studenttrack: false,
      selectedStudents: [],
      formData: {
        glc: "",
        gln: "",
        mdate1: MyFun.getdtnow(),
        mdate2: MyFun.getdtnow(),
        class: "",
        class1: "",
        cldes: "",
      },
      xlslink: "",
      classesList: [],
    };
  },
  methods: {
    toBritish(xdt) {
      return MyFun.tobritish(xdt);
    },
    fillClass() {
      if (this.cmbclass == "") {
        this.formData.class = "";
        this.formData.cldes = "";
        this.formData.class1 = "";
      } else {
        this.formData.class = this.cmbclass.class;
        this.formData.cldes = this.cmbclass.cldes;
        this.formData.class1 = this.cmbclass.class1;
      }
    },
    async getClasses() {
      await axios
        .post("classes.php", {
          optn: "Classes",
          userid: this.userId,
          isteacher: this.$store.state.isTeacher,
        })
        .then((response) => {
          var resp = response.data;
          if (resp.Errorsts == false) {
            this.classesList = resp.List;
          } else {
            console.log("Error:" + resp.ErrorMsg);
          }
        });
    },
    async filterRec() {
      this.loading = true;

      await axios
        .post("teachermsg.php", {
          optn: "TeacherReport",
          frmdata: this.formData,
        })
        .then((resp) => {
          this.loading = false;
          this.studentArr = [];
          if (resp.data.Errorsts == false) {
            var myarr = resp.data.List;
            this.studentArr = myarr;
            console.log(resp);
          } else {
            console.log(resp);
          }
        });
    },
    async exportExcel() {
      this.xlslink = "";
      await axios
        .post("teachermsg.php", {
          optn: "TeacherReportXls",
          frmdata: this.formData,
        })
        .then((resp) => {
          if (resp.data.Errorsts == false) {
            this.xlslink = resp.data.FileLink;
          } else {
            console.log(resp);
          }
        });
    },
    async exportStuExcel() {
      if (this.formData.gln == "") {
        this.errMsg = "Please select student to export.";
        this.errType = "error";
        this.showAlert();
        return;
      }
      this.xlslink = "";
      await axios
        .post("teachermsg.php", {
          optn: "StudentReportXls",
          frmdata: this.formData,
        })
        .then((resp) => {
          if (resp.data.Errorsts == false) {
            this.xlslink = resp.data.FileLink;
          } else {
            console.log(resp);
          }
        });
    },
    clearFilter() {
      this.formData.glc = "";
    },
    showAlert(xtime = 1500) {
      this.alert = true;
      setTimeout(() => {
        this.alert = false;
      }, xtime);
    },
    selectStudent(obj) {
      this.formData.glc = obj.glc;
      this.formData.gln = obj.gln;
      this.closeTrack();
    },
    closeTrack() {
      this.studenttrack = !this.studenttrack;
    },
  },
  async mounted() {
    await this.getClasses();
  },
  computed: {
    studentList() {
      return this.studentArr.filter((rw) => {
        var mystr = rw.gln.trim();
        return mystr.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
};
</script>

<style scoped>
.tbl {
  position: relative;
  display: block;
  width: 800px;
  margin-bottom: 10px;
}

.gln {
  width: 600px;
}

.xlslink {
  position: relative;
  color: green;
  font-weight: bold;
  margin-left: 25px;
}
.form-div {
  position: relative;
  margin: 5px;
  padding: 0px;
  width: calc(100% - 10px);
  border-radius: 5px;
  background-color: white;
  border: 1px solid lightgray;
  top: 10px;
}

.title-bar {
  position: relative;
  display: block;
  padding: 10px;
  width: 100%;
  background-color: #242424;
  color: whitesmoke;
  font-weight: bold;
  text-align: left;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.title-bar div {
  display: inline-block;
}
.close-btn {
  position: relative;
  justify-content: right;
  right: 0px;
  float: right;
  cursor: pointer;
}
.close-btn a {
  position: relative;
  color: white;
  font-size: 20px;
  top: -3px;
}
.close-btn a:hover {
  color: red;
}
.content-area {
  padding: 15px;
}

.btn-area {
  position: relative;
  display: block;
  padding: 5px;
}
.btn-area .exportbtn {
  position: relative;
  float: right;
}

.filter-area {
  padding: 5px;
}

.grid-area {
  padding: 2px;

  width: 100%;
  background-color: white;
  max-height: calc(100vh - (250px));
  overflow: auto;
}
.grid-area table {
  width: 100%;
}
.grid-area table thead {
  position: sticky;
  top: 0px;
  background-color: #242424;
  color: white;
}
.grid-area table tfoot {
  position: sticky;
  bottom: 0px;
  background-color: #242424;
  color: white;
}

.grid-area table thead tr th {
  font-weight: 400;
  padding: 5px;
}

.grid-area table tbody tr td {
  cursor: pointer;
  padding: 5px;
  border-bottom: 0.5px solid lightgray;
}
.grid-area table tbody tr:hover {
  background-color: lightgray;
}

.editcol {
  width: 80px;
}
.srnocol {
  width: 60px;
}

.smalldt {
  position: relative;
  display: block;
  font-size: xx-small;
  font-weight: bold;
}

.dt-filter {
  position: relative;
  display: block;
  font-size: 11px;
  font-weight: bold;
  margin: 0px;
}
.dt-filter label {
  position: relative;
  display: inline-block;
  margin-top: 5px;
  width: 80px;
  left: 4px;
}
.dt-filter .form-control {
  position: relative;
  font-size: 11px;
  font-weight: bold;
  width: 150px;
  display: inline-block;
  margin-bottom: 5px;
}

.dt-filter .form-select {
  position: relative;
  font-size: 11px;
  font-weight: bold;
  width: 250px;
  display: inline-block;
  margin-bottom: 5px;
}

.class-filter {
  margin-top: 0px;
}
.class-filter .col-sm-2 {
  margin-top: 0px;
}
.class-filter .form-select {
  position: relative;
  font-size: 11px;
  margin-bottom: 5px;
}

.class-filter label {
  position: relative;
  font-size: 13px;
  font-weight: bold;
}
.user-filter {
  position: relative;
  display: block;
  font-size: 11px;
  font-weight: bold;
  margin: 0px;
}

.user-filter label {
  position: relative;
  display: inline-block;
  margin-top: 5px;
  width: 80px;
}

.user-filter .form-control {
  position: relative;
  font-size: 11px;
  font-weight: bold;
  display: inline-block;
  margin-bottom: 5px;
}

.filter-btns {
  position: relative;
  display: block;
  margin-bottom: 8px;
}

@media only screen and (max-width: 600px) {
  .grid-area {
    margin-top: 15px;
  }
  .grid-area table thead tr th,
  .grid-area table tbody tr td,
  .grid-area table tfoot tr td {
    padding: 2px;
    font-size: 12px;
  }

  .dt-filter label {
    position: relative;
    display: block;
    width: 80px;
  }
  .dt-filter .form-control {
    position: relative;
    display: block;
    font-size: 11px;
    font-weight: bold;
    width: 100%;
    display: inline-block;
  }

  .dt-filter .form-select {
    position: relative;
    font-size: 11px;
    font-weight: bold;
    width: 100%;
    display: inline-block;
    margin-bottom: 5px;
  }
  .tbl {
    position: relative;
    display: block;
    width: calc(100vw - 60px);
    margin-bottom: 10px;
  }

  .gln {
    width: 100%;
  }
}
</style>
